import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Combobox } from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";
import {
  getProjects,
  GET_DOCUMENT_API,
  ADD_DOCUMENT_API,
  UPDATE_DOCUMENT_API,
} from "../../Constants/apiRoutes";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import LoadingAnimation from "../../Components/Loading/LoadingAnimation";
const functionsList = [
  { id: 1, name: "Technical", uuid: "4251-b2d7-b4c4a7aaf8f8" },
  { id: 2, name: "Finance", uuid: "4251-b2d7-b4c4a7bbf7f7" },
  { id: 3, name: "Human Resources", uuid: "4251-b2d7-b4c4a7ccf6f6" },
  { id: 4, name: "Marketing", uuid: "4251-b2d7-b4c4a7ddf5f5" },
  { id: 5, name: "Sales", uuid: "4251-b2d7-b4c4a7eef4f4" },
  { id: 6, name: "Projects", uuid: "4251-b2d7-b4c4a7fff3f3" },
  { id: 7, name: "Legal", uuid: "4251-b2d7-b4c4a7ggf2f2" },
  { id: 8, name: "Management", uuid: "4251-b2d7-b4c4a7ggf9f9" },
  { id: 9, name: "Others", uuid: "4251-b2d7-b4c4a7hhf1f1" },
];

const ProjectStatus = [
  { id: 1, name: "Project Initiation" },
  { id: 2, name: "Project Planning" },
  { id: 3, name: "Project Execution" },
  { id: 4, name: "Project Control" },
  { id: 5, name: "Project Close" },
];

const AddDocument = () => {
  const navigate = useNavigate();
  const { documentId } = useParams();
  const [documentNo, setDocumentNo] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [statusId, setStatusId] = useState("");
  const location = useLocation();
  const [projectTypeId, setProjectTypeId] = useState("");
  const [statuses] = useState([
    { id: 2, name: "Approved" },
    { id: 1, name: "Pending" },
    { id: 3, name: "Rejected" },
    { id: 4, name: "Cancelled" },
  ]);
  const [projectTypes, setProjectTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // State for combo dropdowns
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusQuery, setStatusQuery] = useState("");
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [projectTypeQuery, setProjectTypeQuery] = useState("");
  const [FunctionID, setFunctionID] = useState("");
  const [documentFile, setDocumentFile] = useState(null); // New state for the uploaded document file

  const [fileSelected, setFileSelected] = useState(false);
  const [fileName, setFileName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [conversionError, setConversionError] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [conversionProgress, setConversionProgress] = useState(0);
  const [showPreviewOption, setShowPreviewOption] = useState(false);
  const [selectedProjectStatus, setSelectedProjectStatus] = useState(null);
  const [projectStatusQuery, setProjectStatusQuery] = useState("");
  const [showError, setShowError] = useState(false);

  const filteredStatuses = ProjectStatus.filter((status) =>
    status.name.toLowerCase().includes(projectStatusQuery.toLowerCase())
  );

  // File handling and conversion functions
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setDocumentFile(file);
      setFileSelected(true);
      setFileName(file.name);
      setErrorMessage("");
      setConversionError("");
      setPreviewUrl(null);
      setConversionProgress(0);
    }
  };
  // Handle document upload with conversion
  const handleUploadDocument = async () => {
    if (
      !documentName ||
      !customerName ||
      !selectedProjectType ||
      !selectedFunction ||
      !selectedProjectStatus ||
      (!documentFile && (!documentId || documentId === "new")) // Only require file for new documents
    ) {
      toast?.error?.("Please fill in all required fields") ||
        console.log("Please fill in all required fields");
      return;
    }

    setIsLoading(true);

    try {
      // Process file first if it's a DOCX (convert to PDF)
      let fileToUpload = documentFile;
      let previewURL = null;

      const formData = new FormData();
      const UserID = localStorage.getItem("UserID");
      if (documentId && documentId !== "new") {
        formData.append("DocumentNo", documentNo);
        formData.append("StatusId", selectedStatus?.id);
          formData.append("UpdatedBy", UserID);
      }
      formData.append("CreatedBy", UserID);
      formData.append("UserID", UserID);
      formData.append("DocumentName", documentName);
      formData.append("CustomerName", customerName);
      formData.append("ProjectTypeId", selectedProjectType.ProjectTypeID);
      formData.append("DepartmentId", selectedFunction.id || " ");
      formData.append("ProjectPhaseId", selectedProjectStatus.id || " ");
      // Append processed file
      if (fileToUpload instanceof File) {
        formData.append("UploadDocument", fileToUpload);
      }

      const tenantId = localStorage.getItem("TenantID");
      if (tenantId) {
        formData.append("TenantId", tenantId);
      }

      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      };

      let response;
      if (documentId && documentId !== "new") {
        response = await axios.put(
          `${UPDATE_DOCUMENT_API}/${documentId}`,
          formData,
          { headers }
        );
      } else {
        response = await axios.post(ADD_DOCUMENT_API, formData, { headers });
      }

      if (response.data.status === "success") {
        toast?.success?.(
          documentId && documentId !== "new"
            ? "Document updated successfully!"
            : "Document added successfully!"
        ) || console.log("Document processed successfully");

        const params = new URLSearchParams(location.search);
        const departmentUUID = params.get("filter");

        // If preview is available, display it
        if (previewURL && showPreviewOption) {
          setPreviewUrl(previewURL);
        }
        const redirectTo = location.state?.from; // read from state

        if (previewURL && showPreviewOption) {
          setPreviewUrl(previewURL);
        }

        setTimeout(() => {
          if (redirectTo) {
            navigate(redirectTo); // go back to where user came from
          } else {
            navigate(`/documentsList?filter=${departmentUUID}`); // fallback if no info
          }
        }, 1000);
      } else {
        toast?.error?.(response.data.message || "Failed to save document") ||
          console.error("Failed to save document");
      }
    } catch (error) {
      console.error("Error saving document", error);
      toast?.error?.("An error occurred while saving the document") ||
        console.error("An error occurred while saving the document");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchProjectTypes = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(getProjects, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const projectTypesData = response.data.data || [];
        setProjectTypes(projectTypesData);

        // Fetch document data after setting project types
        if (documentId && documentId !== "new") {
          fetchDocumentData(projectTypesData); // Pass project types
        }
      } catch (error) {
        console.error("Error fetching project types", error);
      }
    };

    const fetchDocumentData = async (projectTypesData) => {
      if (documentId && documentId !== "new") {
        try {
          const token = localStorage.getItem("token");
          const UserID = localStorage.getItem("UserID");
          const response = await axios.get(
            `${GET_DOCUMENT_API}/${documentId}/${UserID}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const documentData = response.data?.data;

          if (documentData) {
            setDocumentNo(documentData.DocumentNo || "");
            setDocumentName(documentData.DocumentName || "");
            setCustomerName(documentData.CustomerName || "");

            const status = statuses.find((s) => s.id === documentData.StatusId);
            setSelectedStatus(status || null);
            setStatusId(documentData.StatusId);

            // Use passed project types instead of dependency on state
            if (documentData.ProjectTypeName) {
              const projectType = projectTypesData.find(
                (pt) => pt.ProjectTypeName === documentData.ProjectTypeName
              );
              if (projectType) {
                setSelectedProjectType(projectType);
                setProjectTypeId(documentData.ProjectTypeName);
              }
            }
            if (documentData.ProjectPhaseId) {
              const matchedStatus = ProjectStatus.find(
                (status) => status.id === documentData.ProjectPhaseId
              );
              if (matchedStatus) {
                setSelectedProjectStatus(matchedStatus);
              }
            }

            if (documentData.FilePath) {
              setDocumentFile(documentData.FilePath);
            }

            if (documentData.DepartmentId) {
              const func = functionsList.find(
                (f) => f.id === documentData.DepartmentId
              );
              setSelectedFunction(func || null);
              setFunctionID(documentData.DepartmentId);
            }
          }
        } catch (error) {
          console.error("Error fetching document data", error);
          toast.error("Failed to fetch document details");
        }
      }
    };

    fetchProjectTypes();
  }, [documentId]); // Remove projectTypes from dependencies

  const [selectedFunction, setSelectedFunction] = useState(
    functionsList.find((f) => f.id === FunctionID) || null
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const departmentUUID = params.get("filter"); // UUID passed as ?filter=...

    if (departmentUUID) {
      const matchedFunction = functionsList.find(
        (func) => func.uuid === departmentUUID
      );

      if (matchedFunction) {
        setSelectedFunction(matchedFunction); // optional: if used in UI
        setFunctionID({ FunctionID: matchedFunction.id }); // ✅ set ID based on UUID
      }
    }
  }, [location.search, functionsList]);

  const handleCancel = () => {
    const params = new URLSearchParams(location.search);
    const departmentUUID = params.get("filter"); // using UUID from current URL
    navigate(`/documentsList?filter=${departmentUUID}`);
  };

  return (
    <div className="main-container">
      <ToastContainer />
       {isLoading && <LoadingAnimation />}
      <h2 className="text-lg font-semibold mb-4">
        {documentId && documentId !== "new" ? "Update Document" : "Add New Document"}
      </h2>

      <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8 px-16 md:px-24 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Document Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            className="w-full p-2 border rounded-lg"
            placeholder="Enter document name"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Customer Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            className="w-full p-2 border rounded-lg"
            placeholder="Enter customer name"
            required
          />
        </div>

        {/* Status Dropdown */}

        {documentId && documentId !== "new" && (
          <div className="w-full">
            <>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Status <span className="text-red-500">*</span>
              </label>
              <Combobox value={selectedStatus} onChange={setSelectedStatus}>
                <div className="relative">
                  <Combobox.Input
                    className="block w-full rounded-md border border-gray-400 py-2 px-4 shadow-sm sm:text-sm"
                    onChange={(event) => setStatusQuery(event.target.value)}
                    displayValue={(status) => status?.name || ""}
                    placeholder="Select Status"
                  />
                  <Combobox.Button className="absolute inset-y-0 right-0 flex items-center px-2">
                    <ChevronUpDownIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </Combobox.Button>
                  <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {statuses.map((status) => (
                      <Combobox.Option
                        key={status.id}
                        value={status}
                        className="cursor-default select-none py-2 px-4 text-gray-900 hover:bg-indigo-600 hover:text-white"
                      >
                        {status.name}
                      </Combobox.Option>
                    ))}
                  </Combobox.Options>
                </div>
              </Combobox>
            </>
          </div>
        )}
        {/* Project Type Dropdown */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Project Type <span className="text-red-500">*</span>
          </label>
          <Combobox
            value={selectedProjectType}
            onChange={setSelectedProjectType}
          >
            <div className="relative">
              <Combobox.Input
                className="block w-full rounded-md border border-gray-400 py-2 px-4 shadow-sm sm:text-sm"
                onChange={(event) => setProjectTypeQuery(event.target.value)}
                displayValue={(projectType) =>
                  projectType?.ProjectTypeName || ""
                }
                placeholder="Select Project Type"
              />
              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center px-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </Combobox.Button>
              <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {projectTypes.map((projectType) => (
                  <Combobox.Option
                    key={projectType.ProjectTypeID}
                    value={projectType}
                    className="cursor-default select-none py-2 px-4 text-gray-900 hover:bg-indigo-600 hover:text-white"
                  >
                    {projectType.ProjectTypeName}
                  </Combobox.Option>
                ))}
              </Combobox.Options>
            </div>
          </Combobox>
        </div>
        {/* Function Dropdown */}
        <div className="w-full">
          <label
            htmlFor="FunctionID"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Function <span className="text-red-500">*</span>
          </label>
          <Combobox as="div" value={selectedFunction} onChange={() => {}}>
            <div className="relative">
              <Combobox.Input
                id="FunctionID"
                name="FunctionID"
                className="block w-full rounded-md border border-gray-400 py-2 px-4 shadow-sm sm:text-sm bg-gray-100 cursor-not-allowed"
                value={selectedFunction?.name || ""}
                displayValue={() => selectedFunction?.name || ""}
                readOnly
                disabled
              />
              <Combobox.Button
                className="absolute inset-y-0 right-0 flex items-center px-2"
                disabled
              >
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-300"
                  aria-hidden="true"
                />
              </Combobox.Button>
            </div>
          </Combobox>
        </div>

        {/* Project Type Status Dropdown */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Project Type Status <span className="text-red-500">*</span>
          </label>
          <Combobox
            value={selectedProjectStatus}
            onChange={(status) => {
              setSelectedProjectStatus(status);
              setShowError(!status);
            }}
          >
            <div className="relative">
              <Combobox.Input
                className={`block w-full rounded-md border py-2 px-4 shadow-sm sm:text-sm ${
                  showError && !selectedProjectStatus
                    ? "border-red-500"
                    : "border-gray-400"
                }`}
                onChange={(e) => setProjectStatusQuery(e.target.value)}
                displayValue={(status) => status?.name || ""}
                placeholder="Select Project Type Status"
              />
              <Combobox.Button className="absolute inset-y-0 right-0 flex items-center px-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </Combobox.Button>
              <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {filteredStatuses.map((status) => (
                  <Combobox.Option
                    key={status.id}
                    value={status}
                    className="cursor-default select-none py-2 px-4 text-gray-900 hover:bg-indigo-600 hover:text-white"
                  >
                    {status.name}
                  </Combobox.Option>
                ))}
              </Combobox.Options>
            </div>
          </Combobox>
          <p
            className={`text-red-500 text-sm h-5 mt-1 ${
              showError && !selectedProjectStatus ? "visible" : "invisible"
            }`}
          >
            Please select a project status.
          </p>
        </div>
       
        <div className="w-full">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Upload Document{" "}
    {!documentId || documentId === "new" ? (
      <span className="text-red-500">*</span>
    ) : null}
  </label>

  <div className="w-full">
    <input
      type="file"
      onChange={handleFileChange}
      className="block w-full rounded-md border border-gray-400 py-2 px-4 shadow-sm sm:text-sm"
      required={!documentId || documentId === "new"}
    />

    {documentId &&
      documentId !== "new" &&
      documentFile &&
      typeof documentFile === "string" && (
        <p className="text-sm text-gray-600 mt-1">
          Current file: {documentFile.split("/").pop()}
        </p>
      )}
  </div>
</div>

      </div>

      <div className="flex justify-end space-x-2">
        <button
          onClick={handleCancel}
          className="flex items-center px-4 py-2 bg-[#8B4513] text-white rounded-lg"
        >
          <span>Cancel</span>
        </button>
        <button
          onClick={handleUploadDocument}
          className="flex items-center px-4 py-2 bg-[#8B4513] text-white rounded-lg"
        >
          <span>{documentId && documentId !== "new" ? "Update" : "Upload"}</span>
        </button>
      </div>
    </div>
  );
};

export default AddDocument;
